import { render, staticRenderFns } from "./FilterLabel.vue?vue&type=template&id=0b81759d&scoped=true"
import script from "./FilterLabel.vue?vue&type=script&lang=js"
export * from "./FilterLabel.vue?vue&type=script&lang=js"
import style0 from "./FilterLabel.vue?vue&type=style&index=0&id=0b81759d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b81759d",
  null
  
)

export default component.exports